import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { MOMENT_DATE_FORMATS } from '@shared/utils/moment-adapter.util';

export const dateValidator: ValidatorFn = (
  control: AbstractControl,
): { [key: string]: boolean } | null => {
  if(!moment(control.value, MOMENT_DATE_FORMATS.parse.dateInput).isValid()) {
    return { dataInvalida: true };
  } else {
    return null;
  }
};
